import { put } from 'redux-saga/effects'

import { GO_TO_MENU_ROUTE_AND_OPEN } from '@piconetworks/menu-middleware'

import {
    LAUNCHER_TAG,
    HEADER_TAG,
    MENU_TAG,
    PROMPT_TAG,
} from 'common/tags'

import Internal from 'common/modules/internal'
import Router from 'common/modules/router'

import { creators } from '../actions'

export function* focusLauncher(url = '/launcher/icon') {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_launcher',
            ...Router.creators.replace({
                payload: {
                    url,
                },
            }),
        },
    }))

    yield put(creators.hideChild({ frame: PROMPT_TAG }))
    yield put(creators.hideChild({ frame: HEADER_TAG }))
    yield put(creators.hideChild({ frame: MENU_TAG }))
    yield put(creators.showChild({ frame: LAUNCHER_TAG }))
}

export function* focusMenu(menuRoute, data = {}) {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_menu',
            ...Router.creators.replace({
                payload: {
                    url: '/popup-menu',
                },
            }),
        },
    }))
    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_menu',
            ...({
                type: GO_TO_MENU_ROUTE_AND_OPEN,
                payload: {
                    menuRoute,
                    backRoute: '/',
                    ...data,
                },
            }),
        },
    }))
    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_launcher',
            ...Router.creators.replace({
                payload: {
                    url: '/launcher/x',
                },
            }),
        },
    }))

    yield put(creators.hideChild({ frame: PROMPT_TAG }))
    yield put(creators.hideChild({ frame: HEADER_TAG }))
    yield put(creators.showChild({ frame: LAUNCHER_TAG }))
    yield put(creators.showChild({ frame: MENU_TAG }))
}

export function* focusPrompt(entryRoute, queryString) {
    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_prompt',
            ...Router.creators.replace({
                ...(
                    typeof entryRoute === 'string'
                        ? {
                            payload: {
                                url: entryRoute,
                                queryString,
                            },
                        }
                        : {
                            payload: {
                                ...entryRoute,
                                queryString,
                            },
                        }
                ),
            }),
        },
    }))

    yield put(Internal.creators.sendMessage({
        payload: {
            target: 'pico_header',
            ...Router.creators.replace({
                payload: {
                    url: {
                        pathname: '/header-bar',
                        ...(entryRoute === '/registration' && {
                            query: {
                                useDefault: true,
                            },
                        }),
                    },
                },
            }),
        },
    }))
    yield put(creators.showChild({
        frame: PROMPT_TAG,
        popupId: queryString?.popupId,
    }))
    yield put(creators.showChild({ frame: HEADER_TAG }))
    yield put(creators.hideChild({ frame: LAUNCHER_TAG }))
    yield put(creators.hideChild({ frame: MENU_TAG }))
}
